import PropTypes from "prop-types";
import React from "react";
import { Popover } from "reactstrap";
import { createSelector } from "reselect";

import { PropTypeShapes } from "../../types";
import TabLock from "../tabLock";
import { PopoverRepositionContext } from "./PopoverRepositionContext";

const getContextValue = createSelector(
  // input
  scheduleUpdate => scheduleUpdate,
  // output
  scheduleUpdate => {
    return {
      repositionPopover: scheduleUpdate
    };
  }
);

const renderChildren = (disableTabLock, children, scheduleUpdate) => (
  <PopoverRepositionContext.Provider value={getContextValue(scheduleUpdate)}>
    {disableTabLock ? children : <TabLock autoFocus={true}>{children}</TabLock>}
  </PopoverRepositionContext.Provider>
);

const FocusedPopover = ({ disableTabLock, children, ...otherProps }) => {
  return (
    <Popover trigger="legacy" {...otherProps}>
      {({ scheduleUpdate }) => renderChildren(disableTabLock, children, scheduleUpdate)}
    </Popover>
  );
};

FocusedPopover.propTypes = {
  children: PropTypeShapes.elementOrArray.isRequired,
  toggle: PropTypes.func,
  boundariesElement: PropTypes.string,
  disableTabLock: PropTypes.bool.isRequired
};

FocusedPopover.defaultProps = {
  boundariesElement: "viewport",
  disableTabLock: false
};

export default FocusedPopover;
